const enUSMessages = {
  enUS: {
    payment: {
      cards: {
        postcode: 'Zip Code',
      },
      autoRenew: '', // todo: intentionally blank as no A/R
      welcome: {
        renew:
          "The Missouri River Points Pass will launch fully on Thursday 23rd June. You will receive a confirmation email as well as account details to be able to book your golf on the 23rd June. In the meantime, don't forget to refer friends for an additional 10 points each", // todo: blank for US for now (no A/R)
      },
      checkoutTabs: {
        membership: '{membership}',
        payment: 'Account',
        welcome: 'Welcome',
        welcomeBack: 'Welcome Back',
      },
    },
    explore: {
      clubList: {
        miles: 'miles',
        sortBy: {
          favourites: 'Favorites',
        },
        favourites: 'Favorites',
        recentlyPlayed: 'Recently Played',
        mostVisited: 'Most Visited',
      },
    },
    pointsMatrix: {
      list: {
        headerDescription: 'Discover points tariffs at clubs',
        searchByPostcode: 'Search by ZIP Code',
        searchByClubName: 'Search by Club Name',
      },
    },
    userDetails: {
      postcode: 'Zip Code',
      townCity: 'City',
      membershipCancellation: '{membership} Cancellation',
      cancellationDescription: 'If you need to cancel your {membership}, you can do so through insurance.',
      cancelMembership: 'Cancel {membership}',
      cancellationLinkError: 'Unable to load cancellation link. Please try again.',
      noMembershipTransactionsMessage: 'No {membership} transactions found. Please contact PlayMoreGolf support for assistance.',
      retry: 'Retry',
      loadingCancellationLink: 'Loading cancellation link...',
    },
    register: {
      firstName: 'First Name',
      surname: 'Last Name',
      validation: {
        surname: 'Last Name required',
      },
    },
    home: {
      renew: {
        benefit1: {
          body: 'Play golf at the best price.',
          title: 'Great value golf',
        },
        benefit2: {
          body: 'Use our app to make bookings on the go, when it suits you.',
          title: 'Book via our website or app',
        },
        benefit3: {
          body: 'Golf is better with friends, continue to bring along guests or other members.',
          title: 'Bring up to 3 guests',
        },
        benefit4: {
          body: 'Get ahead of the crowd and book in advance',
          title: 'Preferential booking window',
        },
        buttonHelp: 'Renewing now will add another year to your current renewal date.',
        buttonText: 'Renew now',
        title: '',
      },
      topUp: {
        flexi: {
          body: 'Additional Flexi Points can be spent on rounds of golf at any club in the PlayMoreGolf network, including your Home Club. They are valid for 12 months from purchase.',
          info: 'This package will not extend your renewal date.',
          subtitle: 'More points to play at home or away',
          title: 'Flexi  points',
        },
        home: {
          body: 'Additional Home Points can be spent on rounds of golf at your home clubs.',
          info: 'This package will not extend your renewal date.',
          subtitle: 'More points to play at home',
          title: 'Home points',
        },
        lessons: {
          body: 'Lesson packages can be used for golf lessons at your club.',
          info: 'This package will not extend your renewal date.',
          subtitle: 'Golf lessons at your club',
          title: 'Lessons',
        },
        loading: 'Loading top-up packages',
      },
    },
    package: {
      startYourMembershipExplainer: 'Start your membership and receive great benefits',
    },
  },
};

export default enUSMessages;
